// permission_type_enum.ts
export enum PermissionType {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete',
  READ = 'Read',
  VISIBLE = 'Visible',
  MANAGER_APPROVAL = 'ManagerApproval',
}

// permission_level_enum.ts
export enum PermissionLevel {
  APP = 'App',
  MODULE = 'Module',
  FEATURE = 'Feature',
}

// user_permission_type_enum.ts
export enum UserPermissionType {
  ROLE = 'Role',
  USER = 'User',
}

// user_business_restaurant_enum.ts
export enum UserBusinessRestaurantType {
  BUSINESS = 'Business',
  RESTAURANT = 'Restaurant',
}

// roleType.ts
export enum RoleTypeEnum {
  CUSTOMER = 'Customer',
  EMPLOYEE = 'Employee',
  INTERNALUSER = 'InternalUser',
}
